import { IApplicationState } from '../../types/redux';
import { IUserPhone } from '../../types/user';

export const selectAppropriateUserPhone = ({ user }: IApplicationState): IUserPhone | null => {
  if (!user.isAuthenticated || !user.phones) {
    return null;
  }

  const firstConfirmed = user.phones.find(p => p.confirmed);

  return firstConfirmed || user.phones[0];
};
